var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"linkFormSectionWrap"},[_c('unlock-card',{ref:"unlockForm",attrs:{"unlock-data":_vm.unlockData,"show-completion-status":_vm.showCompletionStatus,"completion-done":_vm.completionDone}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }